import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

interface RelatedArticlesProps {
  currentId: string;
  category: string;
}

export default function RelatedArticles({ currentId, category }: RelatedArticlesProps) {
  const related = articles
    .filter((a) => a.id !== currentId && a.category === category)
    .slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            相关爆料
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {related.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}